// import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
// import React, { useState } from "react";
// import { WSIcons } from "../../commonFunctions/iIcons";
// import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";
// import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";

// export const RecentNotification: React.FC<any> = React.memo((props) => {
//   const filters = ["All", "Payments", "Return"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);
//   return (
//     <Paper
//       elevation={0}
//       style={{
//         paddingLeft: 20,
//         paddingRight: 20,
//         marginTop: 40,
//         paddingBottom: 25,
//         borderRadius: "8px",
//       }}
//     >
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={10}>
//           <Typography>Recent Notifications</Typography>
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <ArrowUpwordCorner />
//         </Grid>
//         <Grid item xs={12}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//               // handleFilter(value);
//             }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <Typography>Today</Typography>
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />
//           </IconButton>
//         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             New order #ORD1085 received from Nitin Menon.{" "}
//             <span style={{ color: "#828584" }}>3h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />
//           </IconButton>{" "}
//         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Order #ORD1075 marked as Delivered by delivery agent.{" "}
//             <span style={{ color: "#828584" }}>3h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />
//           </IconButton>{" "}
//         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Order #ORD1078 was cancelled due to wrong medicine.
//             <span style={{ color: "#828584" }}>3h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.TbTruckReturn style={{ color: "#F21E1E", fontSize: 20 }} />
//           </IconButton>{" "}
//         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Return request received for Order #ORD1060.
//             <span style={{ color: "#828584" }}>3h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.BsFileTextFill
//               style={{ color: "#CEEEE5", fontSize: 20 }}
//             />
//           </IconButton>{" "}
//         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Prescription uploaded by customer for Order #ORD1091.{" "}
//             <span style={{ color: "#828584" }}>4h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//  <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.GiEmptyMetalBucket
//               style={{ color: "#F21E1E", fontSize: 20 }}
//             />
//           </IconButton>{" "}        </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Out of stock: Azithromycin 250mg.{" "}
//             <span style={{ color: "#828584" }}>4h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//  <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.GiEmptyMetalBucket
//               style={{ color: "#F21E1E", fontSize: 20 }}
//             />
//           </IconButton>{" "}         </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Only 5 units left: Paracetamol 500mg.{" "}
//             <span style={{ color: "#828584" }}>4h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//         <Grid item xs={12} sm={2}>
//  <IconButton
//             sx={{
//               width: 30,
//               height: 30,
//               borderRadius: "8px",
//               border: "1px solid #828584",
//               p: 0,
//             }}
//           >
//             <WSIcons.PiShieldWarningFill
//               style={{ color: "#F9E78C", fontSize: 20 }}
//             />
//           </IconButton>{" "}             </Grid>
//         <Grid item xs={12} sm={10}>
//           <Typography>
//             Product batch expiry approaching: Crocin 500mg (exp. in 5 days).{" "}
//             <span style={{ color: "#828584" }}>4h</span>
//           </Typography>
//         </Grid>{" "}
//         <Grid item xs={12}>
//           <Divider />
//         </Grid>
//       </Grid>
//     </Paper>
//   );
// });



import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import http from "../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

interface Notification {
  id: string;
  title: string;
  body: string;
  isRead: boolean;
  createdAt: string;
}

interface ApiResponse {
  status: boolean;
  data: Notification[];
}

export const RecentNotification: React.FC<any> = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);
  const [vendorId, setVendorId] = useState<string>("");

  // STEP 1: Get vendorId
  useEffect(() => {
    console.log("🚀 STEP 1: Loading vendorId...");
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 GOT VENDOR:", userId);
    setVendorId(userId || "");
  }, []);

  // STEP 2: Fetch data when vendorId ready
  useEffect(() => {
    console.log("🚀 STEP 2: vendorId changed to:", vendorId);
    if (!vendorId) return;

    console.log("📡 STEP 3: MAKING API CALL...");
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await http.get(`/Notification/vendor/${vendorId}`);
        console.log("📦 STEP 4: API SUCCESS:", response);
        
        // ✅ TYPE SAFE: Handle both response.data and response directly
        let apiData: Notification[] = [];
        if (response?.data && Array.isArray(response.data)) {
          apiData = response.data;
        } else if (Array.isArray(response)) {
          apiData = response;
        }
        
        console.log("✅ STEP 5: RAW DATA:", apiData);
        if (apiData.length > 0) {
          setNotifications(apiData.slice(0, 8));
          console.log("✅ STEP 6: Notifications set:", apiData.length);
        }
      } catch (error: any) {
        console.error("💥 STEP 7: API ERROR:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorId]);

  console.log("🎨 STEP 8: RENDERING:", notifications.length, "notifications");

  if (loading) {
    return (
      <Paper elevation={0} style={{ padding: 20, marginTop: 40, borderRadius: "8px" }}>
        <Typography>Loading...</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 40, paddingBottom: 25, borderRadius: "8px" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
          <Typography>Recent Notifications ({notifications.length})</Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <ArrowUpwordCorner />
        </Grid>
        <Grid item xs={12}>
          <WSFilterButtonGroup 
            options={["All", "Payments", "Return"]} 
            selected="All" 
            onChange={() => {}} 
          />
        </Grid>
        
        {notifications.length === 0 ? (
          <Grid item xs={12} sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="text.secondary">No notifications</Typography>
          </Grid>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography>Today</Typography>
            </Grid>
            {notifications.map((notification, index) => (
              <React.Fragment key={notification.id || `notif-${index}`}>
                <Grid item xs={12} sm={2}>
                  <IconButton sx={{ 
                    width: 30, 
                    height: 30, 
                    borderRadius: "8px", 
                    border: "1px solid #828584", 
                    p: 0 
                  }}>
                    <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                    {notification.title} 
                    {notification.body && `- ${notification.body}`}
                    <span style={{ color: "#828584", marginLeft: 8 }}>
  {notification.createdAt 
    ? new Date(notification.createdAt).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
    : 'No date'}
</span>

                    <Grid item xs={12} sm={7}>
               
              </Grid>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </React.Fragment>
            ))}
          </>
        )}
      </Grid>
    </Paper>
  );
};

export default RecentNotification;
